import { PatchScript } from '@pos-refacto/patchscript-with-react';

import { TransactionSuccessResponse } from '../types';

export function generatePatchScript(str: string): PatchScript {
  return str.split('\n').map(text => ({ type: 'text', pieces: [{ text }] }));
}

export function getAdditionalReceiptData(
  response: undefined | TransactionSuccessResponse['result'][0],
) {
  if (!response) {
    return {};
  }
  const additionalReceiptData: {
    cardholderPatchScript?: PatchScript;
    merchantPatchScript?: PatchScript;
  } = {};
  if (response.customerReceipt) {
    additionalReceiptData.cardholderPatchScript = generatePatchScript(
      'COPY\r\n'.concat(response.customerReceipt),
    );
  }
  if (response.merchantReceipt) {
    additionalReceiptData.merchantPatchScript = generatePatchScript(
      'COPY\r\n'.concat(response.merchantReceipt),
    );
  }
  return additionalReceiptData;
}
